import api from './api';

/**
 * Service d'administration des avis
 * Permet de récupérer la file de modération et d'appliquer des actions
 */
class ReviewAdminService {
  /**
   * Récupère la file de modération des avis
   * @param {Object} options
   * @param {number} [options.page=1]
   * @param {number} [options.limit=20]
   * @param {string} [options.status]
   * @param {boolean} [options.flaggedOnly=false]
   * @param {string} [options.sort='newest']
   * @returns {Promise<Object>} Données et pagination
   */
  async fetchModerationQueue(options = {}) {
    const {
      page = 1,
      limit = 20,
      status,
      flaggedOnly = false,
      sort,
      resubmittedOnly = false
    } = options;

    const params = {
      page,
      limit,
      sort
    };

    if (status) {
      params.status = status;
    }

    if (flaggedOnly) {
      params.flagged_only = 'true';
    }

    if (resubmittedOnly) {
      params.resubmitted_only = 'true';
    }

    params._t = Date.now();

    try {
      const response = await api.get('/reviews/admin/pending', { params });
      const payload = response?.data ?? {};
      const data = payload?.data ?? {};

      return {
        reviews: Array.isArray(data?.data) ? data.data : [],
        pagination: data?.pagination || {
          total: 0,
          totalPages: 1,
          page: Number(params.page) || 1,
          limit: Number(params.limit) || 20
        }
      };
    } catch (error) {
      console.error('[ReviewAdminService] Failed to fetch moderation queue', error);
      throw error;
    }
  }

  /**
   * Applique une action de modération sur un avis
   * @param {string} reviewId
   * @param {Object} payload
   * @returns {Promise<Object>}
   */
  async moderateReview(reviewId, payload) {
    try {
      const response = await api.patch(`/reviews/admin/${reviewId}/moderate`, payload);
      return response.data;
    } catch (error) {
      console.error('[ReviewAdminService] Failed to moderate review', error);
      throw error;
    }
  }
}

const reviewAdminService = new ReviewAdminService();
export default reviewAdminService;
